import * as API from '../'
import $const from '../../common/constant'

export default {
  /**
   *  计划详情
   * @param params
   * @returns {*}
   */
  details: params => {
    return API.GET($const.apiServer.Tranning + '/tranning/training_program_tasks/details', params);
  },

  /**
   *获取文件数据
   * @param params
   * @returns {Promise<*>}
   */
  getFileData: params => {
    return API.GET($const.apiServer.Tranning + '/tranning/enterprise/training-file/file-data', params);
  },

}




// WEBPACK FOOTER //
// ./src/api/training/training_program_tasks.js